<template>

    <div>

        <!-- PRODUCT -->
        <template v-if="contentElement.type.id==contentElementTypes.PRODUCT.id || contentElement.type==contentElementTypes.PRODUCT.id || contentElement.type.id == contentElementTypes.NEU_AM_MARKT.id || contentElement.type.id == contentElementTypes.HAUSAPOTHEKE.id">

            <span class="select is-medium" v-if="products.length > 0">
                <select v-model="pageElement.contentElement.contentElementData[0].product" id="productSelector" @change.prevent="onSelectProduct('productPlacement')">
                    <option :value="null">Produkt wählen ...</option>
                    <option v-for="product in products" :value="product.id">{{ product.name }}</option>
                </select>
            </span>
            <br><br>

            <transition name="fade" appear>

                <div class="productContainer" v-if="product!=null && contentElement.contentElementData.length > 0" :key="product">
                    <product-placement :displayType="currentContentElementType.toUpperCase()" :key="product" :data="product" :settings="{width: 100, isBordered: true, isProportional: true}"></product-placement>
                </div>

            </transition>

            <br />

        </template>


        <!-- all OTHER CONTENT ELEMENTS -->
        <template v-else>

            <template v-for="(element, index) in contentElement.contentElementData" v-if="!isLoading">

                <template v-if="showField(contentElement, element)">
                    <content-form :isReadOnly="isReadOnly" :element="element" :blueprint="contentElement.type.data[index]" :index="index" :products="products" @save="save()" @changeProduct="onSelectProduct" @productBoxType="showProductBoxFields"></content-form>
                </template>

            </template>

            <!-- PRODUCT TIPP -->
            <template v-if="contentElement.type.id==contentElementTypes.ADVICE.id || contentElement.type==contentElementTypes.ADVICE.id">

                <transition name="fade" appear>
                    <div class="productContainer" v-if="product != null">
                        <product-advice :data="productTippData" :settings="{width: 100, isBordered: true, isProportional: true}"></product-advice>
                    </div>
                </transition>

                <br />
            </template>

        </template>


        <modal title="Achtung" transition="fadeDown" :on-ok="onChangeProductConfirm" :on-cancel="onChangeProductCancel" :is-show="showWarning" @close="showWarning=false" cancel-text="Abbrechen">
            <p>Bitte berücksichtigen Sie: eine Änderung des Produktes führt zu einer Änderung des Placement Status.</p>
        </modal>
        <!--  so wird der aktuelle Status dieses Placements auf <i>"Neu / Anlegen (HC)"</i> oder <i>"Layouten (jt)"</i> gesetzt.</p> -->

    </div>

</template>



<script>
import productPlacement from './contentElements/contentElementProductPlacement';
import productAdvice from './contentElements/contentElementAdvice';
import contentForm from './incl-catalogPageElementContentElementForm';

export default {

    props: {

        isReadOnly: {
            type: Boolean,
            default: false
        },
        pageElement: {
            type: Object,
            default: null,
            required: true
        }

    },

    // props: ['isReadOnly', 'pageElement'],

    data() {

		return {
            contentElement: null,
            product: null,
            products: [],
            isLoading: false,
            productBoxTypeId: 47,
            showWarning: false,
            currentContentElementType: null
		}

	},

    components: {
        productPlacement,
        productAdvice,
        contentForm
    },

    computed: {

        boxTypes() {
            return this.$store.getters.getTaxonomies.PRODUCT_BOX_TYPES;
        },

        contentElementTypes() {
            return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_TYPES');
        },

        productStatus() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_STATUS');
        },

        catalogPageElementStatus() {
            return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_ELEMENT_STATUS')
        },

        productTippData() {

        	return [
				{ value: this.contentElement.contentElementData[0].value == "" ? 'Produkt-Tipp' : this.contentElement.contentElementData[0].value},
				{ product: this.product }
			];
		}
    },


    created() {

        // this.data = this.pageElement;
        this.contentElement = this.pageElement.contentElement;

        // fetch the products
        this.fetchProducts();

        // fetch product id if pagelement is of type "product placement"
        if(this.contentElement.type.id == this.contentElementTypes.PRODUCT.id || this.contentElement.type == this.contentElementTypes.PRODUCT.id) {

            this.currentContentElementType = "product";

            // fetch product Data from DB
            this.fetchProduct(this.contentElement.contentElementData[0].product);

        }

        // fetch product if pagelement is of type "advice"
        else if(this.contentElement.type.id == this.contentElementTypes.ADVICE.id || this.contentElement.type == this.contentElementTypes.ADVICE.id) {

            this.currentContentElementType = "advice";

            if(this.contentElement.contentElementData[1] && this.contentElement.contentElementData[1].product != null) {
                this.fetchProduct(this.contentElement.contentElementData[1].product);
            }

        }

        // fetch product if pagelement is of type "neu_am_markt"
        else if(this.contentElement.type.id == this.contentElementTypes.NEU_AM_MARKT.id || this.contentElement.type == this.contentElementTypes.NEU_AM_MARKT.id) {

            this.currentContentElementType = "neu_am_markt";

            if(this.contentElement.contentElementData[0] && this.contentElement.contentElementData[0].product != null) {
              // console.log("---- 1", this.contentElement.contentElementData[0].product);
              this.fetchProduct(this.contentElement.contentElementData[0].product);
            }

        }

        // fetch product if pagelement is of type "hausapo"
        else if(this.contentElement.type.id == this.contentElementTypes.HAUSAPOTHEKE.id || this.contentElement.type == this.contentElementTypes.HAUSAPOTHEKE.id) {

            this.currentContentElementType = "hausapotheke";

            if(this.contentElement.contentElementData[0] && this.contentElement.contentElementData[0].product != null) {
                // console.log("---- 2");
                this.fetchProduct(this.contentElement.contentElementData[0].product);
            }

        }

        else {
          console.log("############# NOT FOUND ##############")
        }
	},

    mounted() {

        //console.log(this.catalogPageElementStatus);

    },

    methods: {

        onSelectProduct() {

            // if selected product is for "product placement"
            if(this.currentContentElementType == 'product' || this.currentContentElementType == 'hausapotheke' ||this.currentContentElementType == 'neu_am_markt') {

                if(this.pageElement.status.name != this.catalogPageElementStatus.CREATED.name) {
                    this.showWarning = true;
                } else {
                    this.fetchProduct(this.contentElement.contentElementData[0].product, false);
                }
            }

            // if selected product is for "product advice"
            else if(this.currentContentElementType == 'advice') {

                if(this.pageElement.status.name != this.catalogPageElementStatus.CREATED.name) {
                    this.showWarning = true;
                } else {
                    this.fetchProduct(this.contentElement.contentElementData[1].product, false);
                }
            }

        },

        onChangeProductConfirm() {

            if(this.currentContentElementType == 'product' || this.currentContentElementType == 'hausapotheke' || this.currentContentElementType == 'neu_am_markt') {
                this.fetchProduct(this.contentElement.contentElementData[0].product, true)
            } else {
                this.fetchProduct(this.contentElement.contentElementData[1].product, true)
            }

        },

        onChangeProductCancel() {

            var self = this;

            // set the product id in contentElementData.product to its initial value
            this.contentElement.contentElementData[0].product = self.product.id;

            // if the user cancelled a product change -
            // reset the selected value in the dropdown to its initial value
            $(document).ready(function() {
                $('select#productSelector').val(self.product.id);
            });

        },

        showField(contentElement, element) {

            if(element.name == "CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_TYPE") {
                this.productBoxTypeId = element.value;
            }

            if(contentElement.type.name != "RICH_TEXT" || element.name == "CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_TYPE") {
                return true;
            }

            // contentElements, which do not have this substring in their name, shouldn't be affected
            if(element.name.indexOf("CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_") == -1) {

                return true;

            } else {

                if(this.productBoxTypeId != this.boxTypes.NONE.id)
                {
                    if(element.name == 'CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_TEXT')
                    {
                        return this.productBoxTypeId == this.boxTypes.LARGE.id;
                    }
                    else
                    {
                        return true;
                    }
                }

            }

        },

        showProductBoxFields: function(element) {
            this.productBoxTypeId = element.value;
        },


        fetchProducts() {

            this.isLoading = true;
            var self = this;
            var url = self.$config.api + 'product?filters[status]=45,63&orderBy=name';

            this.axios.get(url)
                .then(function(response) {
                    self.products = response.data.product;
                    self.isLoading = false;
                });

        },


        fetchProduct(productId, productChange) {

            // clear product data for reactiveness
            this.product = null;

            if(productId == null) {
                return;
            }

	           var self = this;

            this.axios.get(self.$config.api+'product/'+productId+'?include=product.productVouchers,productVoucher.productVoucherProductVariants,product.productVariants,productVariant.voucher,product.productAssets,productAsset.asset,productVariants.productVoucher,productVoucher.preview,productAsset.asset')
				.then(function(response) {

					self.product = response.data;

                //  console.log("currentContentElementType: ", self.currentContentElementType);

                    // if the placement has a status of "created" OR if there was a product change,
                    // we assign the corresponding status of the product to the placement
                    if(
                        (self.currentContentElementType == 'product' || self.currentContentElementType == 'advice' || self.currentContentElementType == 'hausapotheke' || self.currentContentElementType == 'neu_am_markt')
                        && (self.pageElement.status.name == self.catalogPageElementStatus.CREATED.name || productChange == true)) {

                        // if product status is "ACTIVE", set the placement status to "CREATED" (neu anlegen)
                        if(self.product.status == self.productStatus.ACTIVE.id) {
                            // self.pageElement.status = self.catalogPageElementStatus.CREATED;
                            // change 2018-02-01: Placement Status soll mit Auswahl des Produkts automatisch auf "Inhaltl. Feedback" gehen
                            self.pageElement.status = self.catalogPageElementStatus.READY;
                        }

                        // if product status is "APPROVED", set the placement status to "EDITED" (layoutieren)
                        else if(self.product.status == self.productStatus.APPROVED.id) {
                            self.pageElement.status = self.catalogPageElementStatus.EDITED;
                        }
                    }

                    // as we need a comment box for the product in the parent component,
                    // we've to emit the product data
                    self.$emit('productData', response.data);


				}).catch(function(error) {
					console.log(error);
				});

        },

        save() {

            this.$emit("save");

        }

    },

}

</script>


<style scoped>
    .is-6 {
        min-width:70%;
    }
</style>
